<template>
  <div id="app">
    <Nav />
    <Hero />
    <Service />
    <Application />
    <Company />
    <Contact />
    <Footer />
  </div>
</template>

<script>
import Footer from "../components/Footer.vue";
import Service from "../components/Service.vue";
import Contact from "../components/Contact.vue";
import Company from "../components/Company.vue";
import Application from "../components/Application.vue";
import Hero from "../components/Hero.vue";
import Nav from "../components/Nav.vue";
export default {
  name: "home",
  components: {
    Footer,
    Service,
    Contact,
    Company,
    Application,
    Hero,
    Nav
  }
};
</script>
